import { render, staticRenderFns } from "./InformHerBuy.vue?vue&type=template&id=0f280ff3&scoped=true&"
import script from "./InformHerBuy.vue?vue&type=script&lang=js&"
export * from "./InformHerBuy.vue?vue&type=script&lang=js&"
import style0 from "./InformHerBuy.vue?vue&type=style&index=0&id=0f280ff3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f280ff3",
  null
  
)

export default component.exports